import React from 'react';
import { FaSearch } from 'react-icons/fa';
import './SearchBar.css';

const SearchBar = ({
    search,
    setSearch,
    itemsPerPage,
    setItemsPerPage,
    totalItems,
    page,
}) => (
    <div className="product-search-controls">
        <div className="product-search-box">
            <input
                type="text"
                className="product-search-input"
                placeholder="Search Projects, Domain, Tech......"
                value={search}
                onChange={e => setSearch(e.target.value)}
            />
            <FaSearch className="product-search-icon" />
        </div>
        <div className="product-items-filter-group">
            <span className="product-items-label">Items per Page</span>
            <select
                className="product-items-select"
                value={itemsPerPage}
                onChange={e => setItemsPerPage(Number(e.target.value))}
            >
                {[10, 20, 50, 100].map(num => (
                    <option key={num} value={num}>{num}</option>
                ))}
            </select>
        </div>
        <div className="product-items-range">
            {totalItems === 0
                ? '0 results'
                : `${(page - 1) * itemsPerPage + 1}-${Math.min(page * itemsPerPage, totalItems)} of ${totalItems}`}
        </div>
    </div>
);

export default SearchBar;